import React, { Component } from 'react';
import { connect } from 'react-redux'
class DropDownSelect extends Component { // eslint-disable-line react/prefer-stateless-function
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        //   let dropdown
        const { input, data, dis, meta: { touched, error } } = this.props;
        if (data) {
            return (
                <div>
                    <select {...input} className="form-control" disabled={dis}>
                        <option value="">Select</option>
                        {data.map(p => {
                            return (
                                (p.fieldName) ?
                                    <option key={p.fieldName} value={p.fieldName}>{p.fieldName}</option> :
                                    <option key={p} value={p}>{p}</option>
                            )
                        })}
                    </select>
                    {touched && error && <span>{error}</span>}
                </div>
            );
        }
        else {
            return (
                <div>
                    <select {...input} className="form-control" disabled={dis}>
                        <option value="">Select</option>
                    </select>
                    {touched && error && <span>{error}</span>}
                </div>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {

    return {

    }
}
const mapDispatchToProps = (dispatch) => {
    return {

    };//setSearchCounterpartyParameter
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DropDownSelect);